<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">
      <slide>
        <div class="padding">
          <div>
            <p></p>
            <p> &nbsp;</p>
            <p> the changes come faster by the day</p>
            <p> unknown architectures continue to appear around me</p>
            <p> a road runs where yesterday there was only water</p>
            <p> my maps and documents become fiction</p>
            <p> &nbsp;</p>
            <p> I begin to write again</p>
            <p> This time I start with your name</p>
            <p> &nbsp;</p>
            <p> I hope there is still time</p>
            <p> &nbsp;</p>
          </div>
        </div>
      </slide>
      <slide>
        <div class="padding">
          <div>
            <span class="arch">
              <p>I remember when he was a baby, when he first reached out with his hands and we called him a bear.
              He was never Oska then, he was bear, and I even stopped calling him by his name for a few months. I remember that, I know that voice was mine and the child was ours and I know that I loved you. </p>
              <p>I remember his first smile, the moment a tottering step gave way to a series and then to a walk. I remember the smile that creased across his face when he reached you, across that room. You were sat in the sunlight, it caught your hair and set fire to your cheeks and you loved him too. </p>
              <p>I remember the day we parted, </p>
              <p>I remember walking between two worlds and losing you. </p>
              <p> &nbsp;</p>
              <p>I thought I was mad. </p>
              <p>I rewrote my memories every time I recalled something, made each moment more intense, less reliable, less useful to me.</p>
              <p>Then, in her words, I saw the world, the worlds, more clearly. </p>
              <p> &nbsp;</p>
              <p>I've seen the two cities merging,
              two skylines becoming one and I see the water rising and falling between two harbours. </p>
              <p>This cannot hold, the two cannot become the same place here, nor there,
              this one is just an echo</p>
              <p>I know that now</p>
              <p>a city will fall, these pages joining it like ash, </p>
              <p> &nbsp;</p>
              <p>I've searched for a way,</p>
              <p>for a path, maybe even a door</p>
              <p>it seems so foolish now</p>
              <p>and in my search i found only failure</p>
              <p>I tried to tell those around me, </p>
              <p>and of course they laugh and point and joke,</p>
              <p>they thought I was mad</p>
              <p>I become the fool, </p>
              <p>somehow even I laugh now,</p>
              <p> &nbsp;</p>
              <p>Now I watch them pass, i watch their smiles,</p>
              <p>and I am jealous of their ignorance,</p>
              <p>and yet I still want them to know,</p>
              <p>how easily this will all be forgotten,</p>
              <p>how these fragile moments beat like moth wings</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p>To assume another identity, to wear this new life as a fiction. </p>
              <p>It would seem to be the simpler solution, wouldn't it? </p>
              <p>To drift amongst strangers in a fading sea</p>
              <p>I would at least be sure of where I was. </p>
              <p> &nbsp;</p>
              <p>And in what days are left, I could forget what I know</p>
              <p>these moments I remember could fade.</p>
              <p>and I would just wait for this echo to finish sounding out</p>
              <p> &nbsp;</p>

              <p>But this is not where I belong and I know that.</p>
              <p> &nbsp;</p>
              <p>She knows me and she knows how to write this. </p>
              <p>She has written so much, she transcribed a world into pages. </p>
              <p>If she draws that city as real, if she remembers it all clearly, fixes it,
              then there is somewhere for a part of me to live,</p>
              <p>even if only in her memory.</p>
              <p> &nbsp;</p>
              <p>if I can be that to her, </p>
              <p>then maybe I need not care about the coming silence,</p>
              <p>about what happens here,</p>
              <p>about what's left of me in a city she cannot see.</p>
              <p>but this choice is not mine to make</p>
              <p> &nbsp;</p>
              <p>so now </p>
              <p>here, </p>
              <p>in the softest place I could find</p>
              <p> &nbsp;</p>
              <p>the most simple</p>
              <p> &nbsp;</p>
              <p>i just wait </p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
            </span>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Mothwings'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
